import React from 'react';
import { motion } from 'framer-motion';
import { Award, Shield, Lightbulb, CheckCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import './WhyGedik.css';

const WhyGedik = () => {
  const { t } = useTranslation();

  const features = [
    {
      icon: <Award size={32} />,
      title: t('whyGedik.experience'),
      description: t('whyGedik.experienceDesc')
    },
    {
      icon: <Shield size={32} />,
      title: t('whyGedik.quality'),
      description: t('whyGedik.qualityDesc')
    },
    {
      icon: <Lightbulb size={32} />,
      title: t('whyGedik.innovation'),
      description: t('whyGedik.innovationDesc')
    },
    {
      icon: <CheckCircle size={32} />,
      title: t('whyGedik.trust'),
      description: t('whyGedik.trustDesc')
    }
  ];

  return (
    <section className="why-gedik-section" id="why-gedik">
      <div className="why-gedik-container">
        <motion.div
          className="why-gedik-header"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="why-gedik-title">{t('whyGedik.title')}</h2>
          <p className="why-gedik-subtitle">{t('whyGedik.subtitle')}</p>
        </motion.div>

        <div className="values-grid">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              className="value-card"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              whileHover={{ y: -8, scale: 1.02 }}
            >
              <div className="value-icon-wrapper">
                <div className="value-icon">{feature.icon}</div>
              </div>
              <h3 className="value-title">{feature.title}</h3>
              <p className="value-description">{feature.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyGedik;
